module.exports = __webpack_public_path__ + "img/block-768.ee0ceed3.jpg";